"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _jsxRuntime = require("@emotion/react/jsx-runtime");

var _propTypes = require("prop-types");

var _clsx = _interopRequireDefault(require("clsx"));

var _elements = require("../../../styles/elements");

var _icons = require("../../../assets/icons");

var _ProductImage = _interopRequireDefault(require("./ProductImage"));

var _Product = require("./Product.styles");

var Product = function Product(_ref) {
  var name = _ref.name,
      productURl = _ref.productURl,
      children = _ref.children,
      className = _ref.className;
  return (0, _jsxRuntime.jsxs)("div", {
    className: (0, _clsx["default"])('grui overflow-hidden', className),
    children: [productURl ? (0, _jsxRuntime.jsxs)("a", {
      css: [_elements.button.styles.link, _elements.text.styles.fontMedium, _Product.styles.link, process.env.NODE_ENV === "production" ? "" : ";label:Product;"],
      className: "grui flex items-center",
      href: productURl,
      target: "_blank",
      rel: "noopener noreferrer",
      title: name,
      children: [(0, _jsxRuntime.jsx)("span", {
        className: "grui truncate",
        children: name
      }), (0, _jsxRuntime.jsx)(_icons.ExternalLink, {
        className: "grui flex-shrink-0"
      })]
    }) : (0, _jsxRuntime.jsx)("p", {
      className: "grui truncate",
      css: [_elements.paragraph.styles.preflight, _elements.text.styles.textBlack, _elements.text.styles.fontMedium, process.env.NODE_ENV === "production" ? "" : ";label:Product;"],
      children: name
    }), children && (0, _jsxRuntime.jsx)("p", {
      className: "grui truncate",
      css: [_elements.paragraph.styles.preflight, _elements.text.styles.textXs, _elements.text.styles.textDark, _elements.text.styles.fontNormal, process.env.NODE_ENV === "production" ? "" : ";label:Product;"],
      children: children
    })]
  });
};

Product.propTypes = {
  name: _propTypes.string,
  productURl: _propTypes.string,
  children: (0, _propTypes.oneOfType)([_propTypes.string, _propTypes.node]),
  className: _propTypes.string
};
Product.defaultProps = {
  name: '',
  productURl: undefined,
  children: undefined,
  className: undefined
};
Product.Image = _ProductImage["default"];
var _default = Product;
exports["default"] = _default;
//# sourceMappingURL=Product.js.map